import React, { useState } from "react"
import { graphql, useStaticQuery, navigate } from "gatsby"
import cx from "classnames"
import { useFormik } from "formik"
import Input from "./form-input/formInput"
import schema from "./schema"
import './styles.scss'
import { validateEmail } from "../../../util/email"
import { sendMobileBetaApplicationEamil } from "../../../util/mobileBetaEmail"
import { encode } from "../../../util/formUtils"

function MobileApplication({ language }) {
  const { allDataYaml: { edges } } = useStaticQuery(graphql`
    {
      allDataYaml {
        edges {
          node {
            mobilelp {
              application {
                forms {
                  company_name
                  email
                  first_name
                  last_name
                }
                subTitle
                title
                privacyPolicyNotification
                submit
              }
            }
            demo {
              error_messages {
                first_name
                last_name
                email
                company_name
                too_many_signups
                no_personal_email
              }
              submitFail
            }
            language
          }
        }
      }
    }
  `)

  const { node: { mobilelp: { application }, demo: { error_messages, submitFail } } } = edges.find(({node}) => node.language === language)
  const { forms } = application

  const [submitFailed, setSubmitFailed] = useState(false);

  const formik = useFormik({
    initialValues: {
      first_name: "",
      last_name: "",
      email: "",
      company: "",
      language,
    },
    validationSchema: schema,
    validate: (values) => {
      const errors = {};

      const emailErrorType = validateEmail(values.email)

      if (emailErrorType === "tooManySignUps") {
        errors.email = error_messages.too_many_signups;
      }

      if (emailErrorType === "noPersonalEmail") {
        errors.email = error_messages.no_personal_email;
      }

      return errors;
    },
    onSubmit: (values, {setSubmitting, resetForm}) => {
      //1. Save info to netlify
      return fetch("/mobile", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: encode({
          "form-name": "mobile",
          ...values,
          lead_source: document.referrer,
          language: language,
        }),
      })
      .then(() => {
        resetForm()
        const url = language === 'en' ? '/thanks' : '/ja/thanks'
        return navigate(url)
      })
      .catch(err => {
        setSubmitFailed(true)
      })
      .finally(() => {
        setSubmitting(false)
      })
    },
  })

  return <div className="mobile-application">
    <h3 className="mobile-application-heading text-center px-5">{application.title}</h3>
    <div className="mobile-application-subtitle text-center mt-3 mb-3 mb-sm-5">{application.subTitle}</div>
    <div className="mobile-application-form mx-auto">
      <form
        id="demo_request_form"
        name="mobile"
        data-netlify={true}
        netlify-honeypot="bot-field"
        onSubmit={formik.handleSubmit}
      >
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-0">
              <input type="hidden" name="bot-field" />
            </div>
            <div>
              <input type="hidden" name="language" id="mce-LANG" value={language} />
            </div>
            <div className={cx("col-md-6 col-sm-12 mt-sm-4 mt-3 px-3", {"order-1": language === "en", "order-2": language === "ja"})}>
              <Input
                value={formik.values.first_name}
                handleChange={formik.handleChange}
                name="first_name"
                errorText={error_messages.first_name}
                touched={formik.touched.first_name}
                hasError={formik.errors.first_name}
                placeholder={`${forms.first_name}*`}
                id="mce-FNAME"
                className="hoge"
                tabindex={language === "ja" ? 2 : 1}
              />
            </div>

            <div className={cx("col-md-6 col-sm-12 mt-sm-4 mt-3 px-3", {"order-2": language === "en", "order-1": language === "ja"})}>
              <Input
                value={formik.values.last_name}
                handleChange={formik.handleChange}
                name="last_name"
                errorText={error_messages.last_name}
                touched={formik.touched.last_name}
                hasError={formik.errors.last_name}
                placeholder={`${forms.last_name}*`}
                id="mce-LNAME"
                tabindex={language === "ja" ? 1 : 2}
              />
            </div>

            <div className="col-md-6 col-sm-12 mt-sm-4 mt-3 px-3 order-3">
              <Input
                value={formik.values.company}
                handleChange={formik.handleChange}
                name="company"
                errorText={error_messages.company_name}
                touched={formik.touched.company}
                hasError={formik.errors.company}
                placeholder={`${forms.company_name}*`}
                id="mce-COMPANY"
                tabindex={3}
              />
            </div>

            <div className="col-md-6 col-sm-12 mt-sm-4 mt-3 px-3 order-4">
              <Input
                value={formik.values.email}
                handleChange={formik.handleChange}
                name="email"
                errorText={error_messages.email}
                touched={formik.touched.email}
                hasError={formik.errors.email}
                placeholder={`${forms.email}*`}
                id="mce-EMAIL"
                tabindex={4}
              />
            </div>
          </div>
          <div className="row justify-content-center">
            <div className="col-12 px-3">
              <p className="privacy-policy-notification mt-5 mx-auto w-100 w-sm-90 text-left" dangerouslySetInnerHTML={{ __html: application.privacyPolicyNotification }} />
              <div className="mt-5 mx-auto submit-button">
                <button className="btn btn-purple" tabIndex={5}>{application.submit}</button>
              </div>
            </div>
          </div>
          <div className="row justify-content-center">
            {submitFailed && (
              <div className="col-10">
                <div className="requestdemo-error">{submitFail}</div>
              </div>
            )}
          </div>
        </div>
      </form>
    </div>
  </div>
}

export default MobileApplication
